import React from 'react';
import { useForm } from 'react-hook-form';

import { CancelButton, FormButton } from '../../../../../components/Button';
import { FormFieldset } from '../../../../../components/Form';
import Loader from '../../../../../components/Loader';
import { ILeaveId } from '../../Leave.props';
import useEditLeaveRequest from './useEditLeaveRequest';

const EditLeaveRequest: React.FC<ILeaveId> = ({ leaveId, setMethod }) => {
  const { loading, formData, handleChange, handleSubmit, handleDateChange } =
    useEditLeaveRequest(leaveId, setMethod);

  const { handleSubmit: useFormSubmit } = useForm();

  return (
    <div className="flex flex-col items-center w-full h-full pr-8 pl-6">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-fontBlack ml-5">
            Edit Leave Request
          </h1>
        </div>
        {loading && <Loader />}
        <form
          onSubmit={useFormSubmit(handleSubmit)}
          className="space-y-6 p-6 h-[75vh] overflow-y-scroll"
        >
          <FormFieldset Ftitle="Leave Details">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 m-4">
              <div className="flex flex-col">
                <label className="mb-2 text-sm font-medium text-gray-700">
                  Leave Type
                </label>
                <input
                  type="text"
                  value={
                    formData.type === "single" ? "Single Day" : "Multiple Days"
                  }
                  className="border rounded-lg p-2 bg-gray-100"
                  disabled
                />
              </div>

              {formData.type === "single" && (
                <div className="flex flex-col">
                  <label className="mb-2 text-sm font-medium text-gray-700">
                    Sub Type
                  </label>
                  <select
                    name="subtype"
                    value={formData.subtype}
                    onChange={handleChange}
                    className="border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-primary"
                    required
                  >
                    <option value="full">Full Day</option>
                    <option value="half">Half Day</option>
                  </select>
                </div>
              )}

              {formData.type === "single" ? (
                <div className="flex flex-col">
                  <label className="mb-2 text-sm font-medium text-gray-700">
                    Date
                  </label>
                  <input
                    type="date"
                    name="fromDate"
                    value={formData.fromDate}
                    onChange={handleDateChange}
                    min={
                      new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
                        .toISOString()
                        .split("T")[0]
                    }
                    className="border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-primary"
                    required
                  />
                </div>
              ) : (
                <>
                  <div className="flex flex-col">
                    <label className="mb-2 text-sm font-medium text-gray-700">
                      From Date
                    </label>
                    <input
                      type="date"
                      name="fromDate"
                      value={formData.fromDate}
                      onChange={handleDateChange}
                      min={
                        new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
                          .toISOString()
                          .split("T")[0]
                      }
                      className="border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-primary"
                      required
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="mb-2 text-sm font-medium text-gray-700">
                      To Date
                    </label>
                    <input
                      type="date"
                      name="toDate"
                      value={formData.toDate}
                      onChange={handleDateChange}
                      min={formData.fromDate}
                      className="border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-primary"
                      required
                    />
                  </div>
                </>
              )}

              <div className="flex flex-col md:col-span-2">
                <label className="mb-2 text-sm font-medium text-gray-700">
                  Description
                </label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  className="border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-primary h-32"
                  required
                />
              </div>
            </div>
          </FormFieldset>

          <div className="flex justify-center mt-6 ml-2 gap-3">
            <CancelButton
              className="py-2 px-4 h-[56px] w-[200.5px]"
              onClick={setMethod}
              children="Cancel"
              type="button"
            />
            <FormButton
              className="py-2 px-4 h-[56px] w-[200.5px]"
              type="submit"
              children="Update"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditLeaveRequest;
